import { rememberCollectionPath, useLastCollectionPath } from '~/composables/useContinueShopping'

/**
 * Records the last category listing the visitor was on, so a dead end later in
 * the funnel (an emptied cart on checkout) can offer to put them back exactly
 * where they were rather than dumping them on a generic page.
 *
 * A router hook rather than a per-page call: it covers all eight collection
 * routes and any added later, records the URL the visitor actually settled on
 * (pagination, sort and facets all live in the query string), and keeps the
 * bookkeeping out of the page components. Same shape as the analytics plugins,
 * which track page views the same way.
 */
export default defineNuxtPlugin({
  name: 'last-collection',
  setup() {
    const router = useRouter()
    // Resolved here, in plugin setup, where the Nuxt instance is active —
    // `afterEach` runs outside it.
    const remembered = useLastCollectionPath()

    // afterEach does not fire for the navigation that mounted the app, so the
    // entry URL is recorded up front — the pixel plugins seed their first
    // PageView the same way.
    rememberCollectionPath(remembered, router.currentRoute.value.fullPath)

    router.afterEach(to => rememberCollectionPath(remembered, to.fullPath))
  },
})
